import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { htmlToText } from "@/domains/certifications/utils";
import { ContributionBodyProps } from "@/features/certifications/community-flags/types";
import { CONTRIBUTION_KINDS } from "@/domains/certifications/constants";

import "../styles.css";

const ContributionBody = ({
  certification,
  grade,
  context,
  showActivity = false,
}: ContributionBodyProps) => {
  const { t } = useTranslation();
  const isPost = grade.contentKind === CONTRIBUTION_KINDS.POST;
  const topic = certification.modules.find(
    ({ id }) => id === grade.module,
  )?.topic;
  const quotes = [
    context.parentPost && { ...context.parentPost, verb: "posted" },
    context.repliedTo && { ...context.repliedTo, verb: "commented" },
  ].filter((quote) => quote !== null);

  const counts = [
    context.likesCount !== null &&
      t("certification.admin.communityFlags.likes", {
        count: context.likesCount,
      }),
    isPost &&
      context.repliesCount !== null &&
      t("certification.admin.communityFlags.replies", {
        count: context.repliesCount,
      }),
  ].filter(Boolean);

  return (
    <div className="flag-card-body flex flex-col gap-200">
      {isPost && topic && (
        <span className="flag-card-eyebrow body-xs-regular">
          {t("certification.admin.communityFlags.topic", {
            title: topic.title,
          })}
        </span>
      )}

      {quotes.map((quote) => (
        <blockquote
          key={quote.verb}
          className="flag-card-parent flex flex-col gap-50"
        >
          <span className="body-xs-regular">
            {t(`certification.admin.communityFlags.quote.${quote.verb}`, {
              name: quote.authorName,
            })}
          </span>

          <p className="body-s-regular">{quote.text}</p>
        </blockquote>
      ))}

      <p className="flag-card-text body-m-regular">{htmlToText(grade.body)}</p>

      {showActivity && (
        <div className="flex flex-wrap items-center gap-300 body-s-regular">
          {counts.length > 0 && (
            <span className="flag-card-muted">{counts.join(" · ")}</span>
          )}

          {context.discussionId !== null && (
            <Link
              to={`/discussions/${context.discussionId}`}
              target="_blank"
              rel="noreferrer"
              className="flag-card-link"
            >
              {t(
                isPost
                  ? "certification.admin.communityFlags.openPost"
                  : "certification.admin.communityFlags.openComment",
              )}
            </Link>
          )}
        </div>
      )}
    </div>
  );
};

export default ContributionBody;
